<template>
<div>
  <!--    브라우저 분석 -->
  <vs-card class="group-header">
    <h5 class="title">브라우저 분석</h5>
  </vs-card>

  <vs-table
    class="pb-wide mb-6"
    stripe
    ref="table"
    :data="browserList"

    :sst="true">

    <template slot="thead">
      <vs-th class="" sort-key="groupName" >
        <vs-col vs-type="flex"  vs-justify="left" >
          No.
        </vs-col>
      </vs-th>
      <vs-th class="" sort-key="groupName" >
        <vs-col vs-type="flex"  vs-justify="center" >
          브라우저
        </vs-col>
      </vs-th>
      <vs-th class="" >
        <vs-col vs-type="flex"  vs-justify="center" >
          접속자 수
        </vs-col>
      </vs-th>
      <vs-th class="th-fix-management" >
        <vs-col vs-type="flex"  vs-justify="center" >
          비율
        </vs-col>
      </vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

        <!-- NO. -->
        <vs-td >
          {{ indextr }}
        </vs-td>

        <!-- 브라우저 -->
        <vs-td class="text-center">
          {{ data[indextr].browser }}
        </vs-td>

        <!-- 접속자수 -->
        <vs-td class="text-center">
          {{ data[indextr].join }}
        </vs-td>

        <!-- 비율 -->
        <vs-td class="text-center">
          {{ data[indextr].r }}
        </vs-td>

      </vs-tr>
    </template>
  </vs-table>

  <!--    브라우저 통계 -->
  <vs-card class="group-header mb-12">
    <vs-row>
      <h5 class="title w-full mb-4">브라우저 통계</h5>
      <vue-apex-charts class="w-full" type="bar" height="350" :options="browserChart.chartOptions" :series="browserChart.series"></vue-apex-charts>
    </vs-row>
  </vs-card>


  <!--    OS별 분석 -->
  <vs-card class="group-header">
    <h5 class="title">OS별 분석</h5>
  </vs-card>

  <vs-table
    class="pb-wide mb-6"
    stripe
    ref="table"
    :data="osList"

    :sst="true">

    <template slot="thead">
      <vs-th class="" sort-key="groupName" >
        <vs-col vs-type="flex"  vs-justify="left" >
          No.
        </vs-col>
      </vs-th>
      <vs-th class="" sort-key="groupName" >
        <vs-col vs-type="flex"  vs-justify="center" >
          브라우저
        </vs-col>
      </vs-th>
      <vs-th class="" >
        <vs-col vs-type="flex"  vs-justify="center" >
          접속자 수
        </vs-col>
      </vs-th>
      <vs-th class="th-fix-management" >
        <vs-col vs-type="flex"  vs-justify="center" >
          비율
        </vs-col>
      </vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

        <!-- NO. -->
        <vs-td >
          {{ indextr }}
        </vs-td>

        <!-- 브라우저 -->
        <vs-td class="text-center">
          {{ data[indextr].os }}
        </vs-td>

        <!-- 접속자수 -->
        <vs-td class="text-center">
          {{ data[indextr].join }}
        </vs-td>

        <!-- 비율 -->
        <vs-td class="text-center">
          {{ data[indextr].r }}
        </vs-td>

      </vs-tr>
    </template>
  </vs-table>


  <!--    OS별 통계 -->
  <vs-card class="group-header">
    <vs-row>
      <h5 class="title w-full mb-4">OS별 통계</h5>
      <vue-apex-charts class="w-full" type="bar" height="350" :options="osChart.chartOptions" :series="osChart.series"></vue-apex-charts>
    </vs-row>
  </vs-card>

</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'AccessOs',
  components: {
    VueApexCharts
  },
  data () {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      browserList: [
        {
          id: 1,
          browser: 'Google Chrome',
          join: '81',
          r: '1,353%'
        },
        {
          id: 1,
          browser: 'Internet Explorer 10',
          join: '35',
          r: '1,353%'
        },
        {
          id: 1,
          browser: 'Internet Explorer 11',
          join: '31',
          r: '1,353%'
        },
        {
          id: 1,
          browser: 'Mozilla FireFox',
          join: '8',
          r: '1,353%'
        }
      ],
      browserChart: {
        series: [
          {
            data: [81, 35, 31, 7]
          }
        ],
        chartOptions: {
          colors: this.themeColors,
          plotOptions: {
            bar: {

            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: [
              'Google Chrome',
              'Internet Explorer 10',
              'Internet Explorer 11',
              'Mozilla FireFox'
            ]
          }
        }
      },


      osList: [
        {
          id: 1,
          os: 'Linux',
          join: '20',
          r: '12.1234%'
        },
        {
          id: 1,
          os: 'Windows',
          join: '20',
          r: '12.1234%'
        }
      ],
      osChart: {
        series: [
          {
            data: [20, 20]
          }
        ],
        chartOptions: {
          colors: this.themeColors,
          plotOptions: {
            bar: {
              columnWidth: '25%'
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: [
              'Linux',
              'Windows'
            ]
          }
        }
      }

    }
  }
}
</script>

<style>
.group-header { margin-bottom:15px; padding:11px }
.group-header .vs-card--content { display: flex; margin-bottom:0px; }
.group-header .hint { margin-left:16px; }
</style>
